import axios from "axios";
import { MasterDataURL } from "../../../../config/UrlEndPoint";

export const URL = `${MasterDataURL}payment_method`;

// Get PaymentMethod All For use Combobox data
export function getPaymentMethodAll() {
  return axios.get(URL);
}

export function getPaymentMethodAllNotFiltered() {
  return axios.get(`${URL}/not_filtered`);
}

// Get PaymentMethod All For use Combobox data
export function getPaymentMethodAllCompany() {
  return axios.get(`${URL}/allcompany`);
}

// //Get By ID
export function getPaymentMethodById(paymentMethodId) {
  return axios.get(`${URL}/${paymentMethodId}`);
}

// items => filtered/sorted result for table data
export function findPaymentMethod(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the paymentMethod on the server
export function createPaymentMethod(paymentMethod) {
  return axios.post(URL, paymentMethod);
}

// UPDATE => PUT: update the paymentMethod on the server
export function updatePaymentMethod(paymentMethod) {
  return axios.put(`${URL}/${paymentMethod.uuid}`, paymentMethod);
}

// DELETE Payment Gateway
export function deletePaymentMethod(code) {
  return axios.delete(`${URL}/${code}`);
}
